import { render, staticRenderFns } from "./SelectWard.vue?vue&type=template&id=41ef0f24&scoped=true"
import script from "./SelectWard.vue?vue&type=script&lang=js"
export * from "./SelectWard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ef0f24",
  null
  
)

export default component.exports